import { useState } from "react";
import { Button, XMarkIcon } from "@dealer-center/core-components";
import "./Slidebar.scss";
import { FILTER_ICON } from "../utils/utils";

interface SlidebarProps {
  children: React.ReactElement | React.ReactElement[];
  isAbove?: boolean;
}

export const Slidebar = ({ children, isAbove = false }: SlidebarProps) => {
  const [slidebarOpen, setSlidebarOpen] = useState(true);
  return (
    <div className={`slidebar-frame ${slidebarOpen ? "open" : ""}`}>
      {slidebarOpen && isAbove && <div className="slidebar-shade" />}
      <div
        className={`slidebar-content ${isAbove ? "above" : ""} ${slidebarOpen ? "open" : ""}`}
      >
        <div className="slidebar-head">
          <Button
            analyticsConfiguration={{
              eventName: "",
              eventProperties: undefined
            }}
            buttonStyle="tertiary"
            icon={
              slidebarOpen ? (
                <XMarkIcon title="Close menu" />
              ) : (
                <img
                  alt="Open filters"
                  src={FILTER_ICON}
                  style={{ width: 24, height: 24 }}
                />
              )
            }
            onClick={() => {
              setSlidebarOpen(!slidebarOpen);
            }}
          />
        </div>
        <div
          className={`slidebar-body ${slidebarOpen ? "slide-open" : "slide-close"}`}
        >
          <div className="slidebar-content-body">{children}</div>
        </div>
      </div>
    </div>
  );
};
